import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "AppointmentReport.AppointmentReportAiReportViewDialog.title",
    defaultMessage: "Report Summary for {customerName}",
  },
  btnClose: {
    id: "AppointmentReport.AppointmentReportAiReportViewDialog.btnClose",
    defaultMessage: "Close",
  },
  subtitle: {
    id: "AppointmentReport.AppointmentReportAiReportViewDialog.subtitle",
    defaultMessage: "On {date} at {locationCity} — {studyNames}",
  },
  sectionSummary: {
    id: "AppointmentReport.AppointmentReportAiReportViewDialog.sectionSummary",
    defaultMessage: "Summary Of Your Scan",
  },
  sectionFindings: {
    id: "AppointmentReport.AppointmentReportAiReportViewDialog.sectionFindings",
    defaultMessage: "What We Found",
  },
  sectionNextSteps: {
    id: "AppointmentReport.AppointmentReportAiReportViewDialog.sectionNextSteps",
    defaultMessage: "Recommended Next Steps",
  },
});

export default messages;
